import { useCallback, useContext, useEffect, useState } from "react";
import IndiaDataGrid from "../../include/IndiaDataGrid";
import { Box, Button, PaginationItem, Pagination, Container, MenuItem, Typography, useMediaQuery, Chip, TextField,} from "@mui/material";
import { useGridApiRef, gridPageCountSelector, gridPageSelector, useGridSelector } from "@mui/x-data-grid";
import { CheckCircleOutline, InfoOutline, Verified, LocalOffer,} from "@mui/icons-material";
import CampaignAddModal from "../modal/CampaignAddModal";
import { useNavigate } from "react-router-dom";
import { callPostApi } from "../../function/ApiCallFunction";
import GradientLoader from "../CommanComponents/GradientLoader";
import LoadQRCode from "./LoadQRCode";
import { DataContext } from "../../context/DataContext";


function CustomPagination({ apiRef, isMobile }) {
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const handlePageChange = (_, value) => {
    apiRef.current.setPage(value - 1);
    if (isMobile && apiRef.current) {
      setTimeout(() => {
        apiRef.current.autosizeColumns({ includeHeaders: true });
      }, 0);
    }
   }; return (
    <Pagination color="primary" variant="outlined" shape="rounded"  page={page + 1} count={pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />} onChange={handlePageChange} />
  ); }

export function LoadedQR() 
{
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0,});
  const [loading, setLoading] = useState(false);

  const {loginData } = useContext(DataContext);
  const store_id = loginData?.store_info?.store_id;

  const [datar, setDatar] = useState([]);
  const [selectionModel, setSelectionModel] = useState([""]);
  const [filterLimit, setFilterLimit] = useState(100);
  const [filterStatus, setFilterStatus] = useState("Loaded");
  const [filterLotNo, setFilterLotNo] = useState("");
  const [filterLoadedNo, setFilterLoadedNo] = useState("");
  const handleClose = () => setOpen(false);

  const QRListApi = useCallback( async () => 
  {
      try 
      {
          setLoading(true);
         
          const statusMap = { Pending: "0",Loaded: "1",Activated: "2",};
          const qrstatus = statusMap[filterStatus] ?? "";

          const payload = { mod: "CASHI_QECODE_LIST", data_arr: { store_id, genLotNumber: filterLotNo, loadingNumber: filterLoadedNo, 
                            qrcodeStatus: qrstatus, start: "0", limit: filterLimit, }, };
          const apiResult = await callPostApi("cashi-qrcode", payload);

          if (apiResult?.status === "200" && Array.isArray(apiResult?.data)) 
          {      
            const formattedData = apiResult.data.map((item, index) => 
            {
                const statusLabelMap = { "0": "Pending","1": "Loaded","2": "Activated",};
                const dateMap = {"0": item.date_added,"1": item.loading_date,"2": item.active_date,};

                return {
                    id: item.id,
                    sr: index + 1,
                    lotno: item.gen_lot_number || "NA",
                    qr: item.qrcode_number || "NA",
                    expdate: dateMap[item.qrcode_status] || "NA",
                    amount: item.amount || "0",
                    loadedno: item.loading_number || "0",
                    statuss: item.qrcode_status_name || "NA",
                    status: statusLabelMap[item.qrcode_status] || "NA",
                };
              });
              setDatar(formattedData);
          } 
          else { setDatar([]); }
      } 
      catch (err) { setDatar([]); } 
      finally {  setLoading(false);}

  },[store_id, filterStatus,filterLimit,filterLotNo,filterLoadedNo]);

  const clearFun = async () => 
  {
      const newStatus = "Loaded";
      const newLotNo = "";
      const newLoadedNo = "";
      const newlimit = 100;
      setFilterLimit(newlimit);
      setFilterStatus(newStatus);
      setFilterLotNo(newLotNo);
      setFilterLoadedNo(newLoadedNo);
      await QRListApi(newStatus, newLotNo, newLoadedNo,newlimit);
  };

  useEffect(() => 
  {
    QRListApi();
  }, [QRListApi]);

  const columns = [
    { field: "sr",     headerName: "Sr no.",   lex: isMobile ? undefined : 0.5 },
    { field: "qr",     headerName: "QR",       flex: isMobile ? undefined : 1 },
    { field: "amount", headerName: "Amount",   flex: isMobile ? undefined : 1 },
    { field: "status", headerName: "Status",   flex: isMobile ? undefined : 1,
      renderCell: (params) => {
        let color = "default";
        let icon = null;
        let border = "default";
        switch (params.value) {
          case "Activated":
            color = "#098665";
            border = "1px solid #098665";
            icon = <Verified sx={{ fontSize: 18 }} />;
            break;
          case "Pending":
            color = "#e9aa0aff";
            border = "1px solid #e9aa0aff";
            icon = <InfoOutline sx={{ fontSize: 18 }} />;
            break;
          case "Loaded":
            color = "#0a32d4ff";
            border = "1px solid #0a32d4ff";
            icon = <CheckCircleOutline sx={{ fontSize: 18 }} />;
            break;
          default:
            color = "default";
        }
        return (
          <Chip icon={icon} label={params.value || "Unknown"} variant="outlined" color={color}
            sx={{ borderRadius: "18px", fontWeight: 500, border: { border }, color: { color },}} />
        ); }, },
    { field: "lotno",     headerName: "Lot Number",      flex: isMobile ? undefined : 1 },
    { field: "loadedno",  headerName: "Loading Number",  flex: isMobile ? undefined : 1,},
    { field: "expdate",   headerName: "Date",            flex: isMobile ? undefined : 1 },
  ];

  return (
    <>
      <Container maxWidth="xl" sx={{ my: 2 }}>
      
        <Box sx={{ display: "flex", justifyContent: "start", mb: 2 }}>
          <Button variant="contained" sx={{ backgroundColor: "#000000", color: "#ffffff" }} onClick={() => navigate(-1)} >
            Back
          </Button>
        </Box>

        <Typography variant="h6" gutterBottom sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)", p: 1, color: "#ffffff", 
           borderRadius: "4px", mb: 3, display: "flex", alignItems: "center", }} >
          <LocalOffer sx={{ mr: 1 }} /> Loaded QR
        </Typography>

        {/* Activate Button */}
        <Box sx={{ mb: 4, display: "flex", justifyContent: "end" }}>
          <LoadQRCode idsss={selectionModel} onSuccess={() => { QRListApi(); }} apiRef={apiRef} />
        </Box>
        
        {/* Filter */}
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
          <TextField select label="Filter Status" value={filterStatus} onChange={(e) => { setFilterStatus(e.target.value); }} 
            sx={{ minWidth: 140 }} >
            <MenuItem value="Loaded">Loaded</MenuItem>
          </TextField>
          <TextField type="text" label="Lot Number" value={filterLotNo} onChange={(e) => setFilterLotNo(e.target.value)} sx={{ minWidth: 140 }}>
           </TextField>
          <TextField type="text" label="Loading Number" value={filterLoadedNo} onChange={(e) => setFilterLoadedNo(e.target.value)}
            sx={{ minWidth: 140 }} />
          <TextField select label="Limit" value={filterLimit} onChange={(e) => { setFilterLimit(e.target.value); }}
            sx={{ minWidth: 140 }}>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={300}>300</MenuItem>
            <MenuItem value={500}>500</MenuItem>
            <MenuItem value={2000}>All</MenuItem>
          </TextField>
          <Button variant="outlined" color="primary" sx={{ height: 56 }}
            onClick={() => { QRListApi(filterStatus, filterLotNo, filterLoadedNo); }} >
            Apply Filter
          </Button>
          <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => { clearFun(); }} >
            Clear Filter
          </Button>
        </Box>

        {/* DataGrid */}
        <Box sx={{ height: "auto", width: "100%", mb: 4 }}>
          <IndiaDataGrid  apiRef={apiRef} rows={datar}  columns={columns} showToolbar  checkboxSelection getRowHeight={() => "auto"}
            slots={{ pagination: () => ( <CustomPagination apiRef={apiRef} isMobile={isMobile} /> ), }}
            paginationModel={paginationModel} onPaginationModelChange={setPaginationModel}
            onRowSelectionModelChange={(newRowSelectionModel) => { setSelectionModel(newRowSelectionModel); }}
            selectionModel={selectionModel}
            sx={{
              "& .MuiDataGrid-cell": {
                whiteSpace: "normal",
                wordBreak: "break-word",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f0f0f0",
                color: "#000",
                fontWeight: "bold",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: 14,
                fontWeight: 600,
                whiteSpace: "normal",
                wordBreak: "break-word",
              },
            }}
          />
        </Box>

        {/* Add Campaign Dialog */}
        <CampaignAddModal open={open} onClose={handleClose} />

        {/* Detail Dialog */}
      </Container>
      {loading && <GradientLoader text="Loading" />}      {/* Loader */} 
    </>
  );
}
